import React, { useState } from 'react'
import { Form, Row, Col,Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { setColorTc, initialState } from '../../store/modules/colorplate';
import langList from '../../utils/languagelist.json'

export default function Colorstandout() {
  const {...colorValue}=useSelector((state)=>state.colorplate);
  const {lg}=useSelector((state)=>state.language);
  const dispatch=useDispatch();
  const [selectedColor, setSelectedColor] = useState(colorValue.tc);
  const [checkValue, setCheckValue] = useState(false);

  const handleClick = () => {
    colorValue['tc'] = selectedColor;
    dispatch(setColorTc(colorValue))
    localStorage.setItem('color', JSON.stringify(colorValue));
  }

  const handleChang = (index,value) => {
    if(checkValue) return;
    const newSelectedColor={...selectedColor}
    newSelectedColor[index]=value;
    setSelectedColor(newSelectedColor)
  }

  const handleCheckChang = (e) => {
    setCheckValue(e.target.checked)
    if(e.target.checked){
      setSelectedColor(initialState.tc)
    };
  }
  
  return (
    <div>
      <Row xs={2} className="g-1">
        <Col className="d-flex justify-content-center">
          <div>{langList.colorstandout1[lg]}</div>
        </Col>
        <Col className="d-flex justify-content-center">
          <div>{langList.colorstandout2[lg]}</div>
        </Col>
        <Col className="d-flex justify-content-center">
          <Form.Control
            type="color" id='ColorInput50'
            value={selectedColor.jz}
            onChange={e=>handleChang('jz',e.target.value)}
          />
        </Col>
        <Col className="d-flex justify-content-center">
          <Form.Control
            type="color" id='ColorInput51'
            value={selectedColor.hz}
            onChange={e=>handleChang('hz',e.target.value)}
          />
        </Col>
      </Row>
      <Row className="pt-3">
        <Form.Check
          type='checkbox'
          id='standoutcheckbox'
          label={langList.colorcell1[lg]}
          checked={checkValue}
          onChange={handleCheckChang}
        />
      </Row>
      <Row className="pt-3">
        <Button variant="outline-primary" size="sm"
        onClick={handleClick}
        >{langList.public7[lg]}</Button>
      </Row>
    </div>
  )
};

